import { useEffect, useState } from "react";
import { DownloadSimple, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function InstallEdujac() {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showIosHelp, setShowIosHelp] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    if (isStandalone) {
      setInstalled(true);
      return;
    }

    const syncStoredPrompt = () => {
      if (window.deferredEdujacInstallPrompt) {
        setInstallPrompt(window.deferredEdujacInstallPrompt);
      }
    };

    const handleAppInstalled = () => {
      setInstalled(true);
      setInstallPrompt(null);
      setShowIosHelp(false);
    };

    syncStoredPrompt();

    window.addEventListener("edujac-install-available", syncStoredPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener(
        "edujac-install-available",
        syncStoredPrompt
      );
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const isIos =
    /iphone|ipad|ipod/i.test(window.navigator.userAgent) &&
    !window.MSStream;

  const install = async () => {
    if (installPrompt) {
      await installPrompt.prompt();
      await installPrompt.userChoice;
      window.deferredEdujacInstallPrompt = null;
      setInstallPrompt(null);
      return;
    }

    if (isIos) {
      setShowIosHelp(true);
    }
  };

  if (installed) {
    return null;
  }

  if (!installPrompt && !isIos) {
    return null;
  }

  return (
    <div className="mt-4">
      <Button
        type="button"
        variant="outline"
        onClick={install}
        className="w-full rounded-full border-[#00194E] text-[#00194E] font-bold"
      >
        <DownloadSimple size={18} className="mr-2" />
        Install EDUJAC App
      </Button>

      {showIosHelp && (
        <div className="relative mt-3 rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-600">
          <button
            type="button"
            aria-label="Close install instructions"
            onClick={() => setShowIosHelp(false)}
            className="absolute right-3 top-3 text-slate-400 hover:text-slate-700"
          >
            <X size={16} />
          </button>

          <p className="font-semibold text-[#00194E]">
            Install EDUJAC on iPhone or iPad
          </p>

          <p className="mt-2 pr-5">
            Open EDUJAC in Safari, tap the Share button, choose
            <strong> Add to Home Screen</strong>, then tap
            <strong> Add</strong>.
          </p>
        </div>
      )}
    </div>
  );
}
